import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Select,
    Input,
    Space,
    Card, message, Descriptions, Divider
} from "antd";
import { Button, Drawer } from "@mantine/core";
import dayjs from "dayjs";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { Get_user_topin_requests } from "../../../apicall";

const { RangePicker } = DatePicker;
const { Search } = Input;
const { Text } = Typography;

const initialData = [
    {
        key: 1,
        requestId: "REQ100001",
        status: "Success",
        mode: "IMPS",
        utr: "UTR987654321",
        amount: 5000,
        fee: 10,
        netAmount: 4990,
        date: "24-Jun-2025 10:20 AM",
        remarks: "Amount Credited",
    },
    {
        key: 2,
        requestId: "REQ100002",
        status: "Pending",
        mode: "NEFT",
        utr: "UTR987654322",
        amount: 10000,
        fee: 20,
        netAmount: 9980,
        date: "24-Jun-2025 11:30 AM",
        remarks: "Processing",
    },
    {
        key: 3,
        requestId: "REQ100003",
        status: "Failed",
        mode: "RTGS",
        utr: "UTR987654323",
        amount: 2500,
        fee: 0,
        netAmount: 2500,
        date: "24-Jun-2025 01:15 PM",
        remarks: "Account Invalid",
    },
    {
        key: 4,
        requestId: "REQ100004",
        status: "Success",
        mode: "IMPS",
        utr: "UTR987654324",
        amount: 15000,
        fee: 25,
        netAmount: 14975,
        date: "25-Jun-2025 09:40 AM",
        remarks: "Completed",
    },
];

const RequestHistorydist = () => {
    const today = dayjs();
    const [dateRange, setDateRange] = useState([
        today.startOf("day"),
        today.endOf("day"),
    ]);
    const [status, setStatus] = useState("ALL");
    const [utr, setUtr] = useState("");
    const { user } = Userauthcontexthooks();
    const [topinreqloading, settopinreqloading] = useState(true);
    const [allTopinReq, setAllTopinReq] = useState([]);
    const [topinReq, setTopinreq] = useState([]);
    const [detailsDrawer, setDetailsDrawer] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);

    const handleSearch = () => {

        let filtered = [...allTopinReq];

        if (status !== "ALL") {

            filtered = filtered.filter(
                item => item.status === status
            );

        }

        if (utr.trim()) {

            filtered = filtered.filter(item =>
                item.utr
                    ?.toLowerCase()
                    .includes(utr.toLowerCase())
            );

        }

        setTopinreq(filtered);

    }

    const handleReset = () => {

        const today = dayjs();

        setDateRange([
            today.startOf("day"),
            today.endOf("day")
        ]);

        setStatus("ALL");

        setUtr("");

        // No need to manually reset topinReq.
        // dateRange changes → backend fetches today's data.
    }
    const fetchTopinRequests = async () => {

        try {
            const data = await Get_user_topin_requests(
                dateRange[0].format("YYYY-MM-DD"),
                dateRange[1].format("YYYY-MM-DD")
            );

            if (data.success) {
                //console.log(data);

                setAllTopinReq(data?.topinRequests);

                setTopinreq(data?.topinRequests);
            }

        } catch (error) {

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            settopinreqloading(false);
        }

    }

    const columns = [
        {
            title: "Req. ID",
            dataIndex: "topinId",
            width: 20,
        },

        {
            title: "Status",
            dataIndex: "status",
            width: 20,
            render: (status) => {
                let color = "default";

                if (status === "SUCCESS") color = "green";
                if (status === "PENDING") color = "orange";
                if (status === "FAILED") color = "red";

                return <Tag color={color}>{status}</Tag>;
            },
        },

        {
            title: "Mode",
            dataIndex: "depositeType",
            width: 20,
        },

        {
            title: "UTR",
            dataIndex: "utr",
            width: 180,
            render: (utr) => <Text copyable>{utr}</Text>,
        },

        {
            title: "Amount",
            dataIndex: "amount",
            align: "right",
            width: 80,
            render: (amount) => `₹ ${amount.toLocaleString()}`,
        },

        {
            title: "Fee",
            dataIndex: "fee",
            align: "right",
            width: 80,
            render: (fee) => `₹ ${fee?.toLocaleString()}`,
        },

        {
            title: "Net Amount",
            dataIndex: "netAmount",
            align: "right",
            width: 80,
            render: (net) => (
                <Text strong style={{ color: "#1677ff" }}>
                    ₹ {net?.toLocaleString()}
                </Text>
            ),
        },

        {
            title: "Date",
            dataIndex: "createdAt",
            align: "right",
            width: 120,
            render: (date) => (
                <>
                    <div>{dayjs(date).format("DD MMM YYYY")}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        {dayjs(date).format("hh:mm A")}
                    </Text>
                </>
            ),
        },

        {
            title: "Remarks",
            width: 150,
            align: "right",
            render: (_, record) => {
                const admin = record.adminRemarks;

                return (
                    <>
                        <Tag
                            color={
                                admin?.adminaction === "APPROVED"
                                    ? "green"
                                    : admin?.adminaction === "REJECTED"
                                        ? "red"
                                        : "orange"
                            }
                        >
                            {admin?.adminaction || "Pending"}
                        </Tag>

                        <div style={{ marginTop: 4 }}>
                            <Text type="secondary">
                                {admin?.adminapproveremarks ||
                                    admin?.adminrejectremarks ||
                                    record.remarks ||
                                    "-"}
                            </Text>
                        </div>
                    </>
                );
            },
        },
        {
            title: "Action",
            width: 100,
            align: "center",
            render: (_, record) => (
                <Button
                    size="xs"
                    variant="outline"

                    onClick={() => {
                        setSelectedRequest(record);
                        setDetailsDrawer(true);
                    }}
                >
                    View
                </Button>
            )
        }
    ];

    useEffect(() => {
        const fetchTopinRequests = async () => {

            try {
                const data = await Get_user_topin_requests(
                    dateRange[0].format("YYYY-MM-DD"),
                    dateRange[1].format("YYYY-MM-DD")
                );

                if (data.success) {
                    //console.log(data);

                    setAllTopinReq(data?.topinRequests);

                    setTopinreq(data?.topinRequests);
                }

            } catch (error) {

                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                settopinreqloading(false);
            }

        }
        if (user) {
            fetchTopinRequests();
        }

    }, [user, dateRange]);

    return (
        <>
            <Card title="Request History" style={{
                width: "100%",
            }}>
                <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                    <Col xs={24} md={8}>
                        <RangePicker
                            style={{ width: "100%" }}
                            value={dateRange}
                            onChange={(value) => setDateRange(value)}
                            allowClear={false}
                        />
                    </Col>

                    <Col xs={24} md={4}>
                        <Select
                            value={status}
                            onChange={setStatus}
                            style={{ width: "100%" }}
                            options={[
                                { label: "All Status", value: "ALL" },
                                { label: "SUCCESS", value: "SUCCESS" },
                                { label: "PENDING", value: "PENDING" },
                                { label: "FAILED", value: "FAILED" },
                            ]}
                        />
                    </Col>

                    <Col xs={24} md={6}>
                        <Search
                            placeholder="Search UTR"
                            allowClear
                            value={utr}
                            onChange={(e) => setUtr(e.target.value)}
                            onSearch={handleSearch}
                        />
                    </Col>

                    <Col xs={24} md={6}>
                        <Space>
                            <Button onClick={handleSearch}>
                                Search
                            </Button>

                            <Button onClick={handleReset} variant="light">Reset</Button>
                            <Button onClick={fetchTopinRequests} variant="outline">Refresh</Button>
                        </Space>
                    </Col>
                </Row>

                <div style={{ width: "100%", overflowX: "auto" }}>
                    <Table
                        columns={columns}
                        dataSource={topinReq}
                        bordered
                        size="middle"
                        loading={topinreqloading}
                        rowKey="_id"
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: true,
                        }}
                    // scroll={{ x: 1200 }}
                    />
                </div>
            </Card>
            <Drawer
                title="Top-In Request Details"
                placement="right"
                width={550}
                opened={detailsDrawer}
                onClose={() => {
                    setDetailsDrawer(false);
                    setSelectedRequest(null);
                }}
            >
                {selectedRequest && (
                    <>
                        {/* Request Details */}

                        <Divider orientation="left">
                            Request Details
                        </Divider>

                        <Descriptions
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="Request ID">
                                {selectedRequest.topinId}
                            </Descriptions.Item>

                            <Descriptions.Item label="Status">
                                <Tag
                                    color={
                                        selectedRequest.status === "SUCCESS"
                                            ? "green"
                                            : selectedRequest.status === "FAILED"
                                                ? "red"
                                                : "orange"
                                    }
                                >
                                    {selectedRequest.status}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Deposit Type">
                                {selectedRequest.depositeType}
                            </Descriptions.Item>

                            <Descriptions.Item label="Deposit Date">
                                {dayjs(selectedRequest.depositeDate).format(
                                    "DD MMM YYYY"
                                )}
                            </Descriptions.Item>

                            <Descriptions.Item label="Created On">
                                {dayjs(selectedRequest.createdAt).format(
                                    "DD MMM YYYY hh:mm A"
                                )}
                            </Descriptions.Item>

                            <Descriptions.Item label="UTR">
                                <Text copyable>
                                    {selectedRequest.utr}
                                </Text>
                            </Descriptions.Item>

                            <Descriptions.Item label="Amount">
                                ₹ {selectedRequest.amount.toLocaleString()}
                            </Descriptions.Item>

                            <Descriptions.Item label="Fee">
                                ₹ {selectedRequest.fee.toLocaleString()}
                            </Descriptions.Item>

                            <Descriptions.Item label="Net Amount">
                                <Text strong style={{ color: "#1677ff" }}>
                                    ₹ {selectedRequest.netAmount?.toLocaleString()}
                                </Text>
                            </Descriptions.Item>

                            <Descriptions.Item label="User Remarks">
                                {selectedRequest.remarks || "-"}
                            </Descriptions.Item>

                        </Descriptions>

                        {/* Bank */}

                        <Divider orientation="left">
                            Bank Details
                        </Divider>

                        <Descriptions
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="A/C Number">
                                {selectedRequest.bank?.accountNumber || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="IFSC Code">
                                {selectedRequest.bank?.ifscCode || "-"}
                            </Descriptions.Item>

                        </Descriptions>

                        {/* Admin */}

                        <Divider orientation="left">
                            Admin Action
                        </Divider>

                        <Descriptions
                            bordered
                            column={1}
                            size="small"
                        >

                            <Descriptions.Item label="Action">

                                <Tag
                                    color={
                                        selectedRequest.adminRemarks?.adminaction ===
                                            "APPROVED"
                                            ? "green"
                                            : selectedRequest.adminRemarks
                                                ?.adminaction === "REJECTED"
                                                ? "red"
                                                : "orange"
                                    }
                                >
                                    {selectedRequest.adminRemarks?.adminaction ||
                                        "Pending"}
                                </Tag>

                            </Descriptions.Item>

                            <Descriptions.Item label="Approved By">
                                {selectedRequest.adminRemarks?.adminby || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Approval Remarks">
                                {selectedRequest.adminRemarks
                                    ?.adminapproveremarks || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Reject Remarks">
                                {selectedRequest.adminRemarks
                                    ?.adminrejectremarks || "-"}
                            </Descriptions.Item>

                        </Descriptions>
                    </>
                )}
            </Drawer>
        </>

    );
};

export default RequestHistorydist;